import Image from "next/image";
import { Dialog, Typography } from "@earned/core";
import { useWhatsNewModalGate } from "../../hooks";

export default function WhatsNewModalMount() {
  const { shouldOpen, dismiss } = useWhatsNewModalGate();

  return (
    <Dialog
      isOpen={shouldOpen}
      onClose={dismiss}
      title="What's New"
      onSubmit={dismiss}
      onSubmitText="Done"
      hideCloseText
      size="sm"
    >
      <div className="flex flex-col gap-5">
        <Typography variant="body" color="primary">
          Check out Earned Additional Services
        </Typography>
        <Image
          src="/images/whats-new/additional-services.png"
          alt="Additional Services preview"
          width={568}
          height={364}
          className="h-auto w-full"
        />
        <Typography variant="body" color="primary">
          Transactions, Categories, Trends, and Budgets are now conveniently
          located under Spending
        </Typography>
        <Image
          src="/images/whats-new/wealth.png"
          alt="Wealth section preview with Spending highlighted"
          width={491}
          height={351}
          className="h-auto w-full"
        />
      </div>
    </Dialog>
  );
}
